import { render } from "./SpinnerModal.vue?vue&type=template&id=38f99590&scoped=true"
import script from "./SpinnerModal.vue?vue&type=script&lang=js"
export * from "./SpinnerModal.vue?vue&type=script&lang=js"

import "./SpinnerModal.vue?vue&type=style&index=0&id=38f99590&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38f99590"

export default script